import {Container} from '@material-ui/core'
import _ButtonSmall from 'src/components/Buttons/ButtonSmall'
import Styled from 'src/components/Styled'
import styles from './styles'

export const EditButton = _ButtonSmall

export const Root = Styled(Container, styles.root)
